import { TileEdgeDirection, TileCornerDirection } from '@colonist/game-states';
// coordinate system: https://prntscr.com/w5qoib
export class Point {
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
export class HexFace {
    get id() {
        return `${this.x}-${this.y}`;
    }
    neighbors() {
        const neighborArray = [];
        neighborArray.push(new HexFace(this.x + 1, this.y - 1));
        neighborArray.push(new HexFace(this.x + 1, this.y));
        neighborArray.push(new HexFace(this.x, this.y + 1));
        neighborArray.push(new HexFace(this.x - 1, this.y + 1));
        neighborArray.push(new HexFace(this.x - 1, this.y));
        neighborArray.push(new HexFace(this.x, this.y - 1));
        return neighborArray;
    }
    corners() {
        const cornerArray = [];
        cornerArray.push(new HexCorner(this.x, this.y, TileCornerDirection.North));
        cornerArray.push(new HexCorner(this.x + 1, this.y - 1, TileCornerDirection.South));
        cornerArray.push(new HexCorner(this.x, this.y + 1, TileCornerDirection.North));
        cornerArray.push(new HexCorner(this.x, this.y, TileCornerDirection.South));
        cornerArray.push(new HexCorner(this.x - 1, this.y + 1, TileCornerDirection.North));
        cornerArray.push(new HexCorner(this.x, this.y - 1, TileCornerDirection.South));
        return cornerArray;
    }
    edges() {
        const edgeArray = [];
        edgeArray.push(new HexEdge(this.x + 1, this.y - 1, TileEdgeDirection.SouthWest));
        edgeArray.push(new HexEdge(this.x + 1, this.y, TileEdgeDirection.West));
        edgeArray.push(new HexEdge(this.x, this.y + 1, TileEdgeDirection.NorthWest));
        edgeArray.push(new HexEdge(this.x, this.y, TileEdgeDirection.SouthWest));
        edgeArray.push(new HexEdge(this.x, this.y, TileEdgeDirection.West));
        edgeArray.push(new HexEdge(this.x, this.y, TileEdgeDirection.NorthWest));
        return edgeArray;
    }
    sameFace(hexFace) {
        if (this.x != hexFace.x) return false;
        if (this.y != hexFace.y) return false;
        return true;
    }
    // Starting point is the center of the whole map. Radius is the length from center of the hexagon to the corner of the hexagon
    toPixel(startingPoint, radius) {
        // noinspection TsLint I don't remember what these number were for
        const px = radius * Math.sqrt(3) * (this.x + this.y / 2) + startingPoint.x;
        // noinspection TsLint I don't remember what these number were for
        const py = radius * 3 / 2 * this.y + startingPoint.y;
        return new Point(px, py);
    }
    constructor(x, y){
        this.x = x;
        this.y = y;
    }
}
export class HexCorner {
    get id() {
        return `${this.x}-${this.y}-${this.z}`;
    }
    // Radius is half of hexagon height
    toPixel(startingPoint, radius) {
        const hexagonPixel = new HexFace(this.x, this.y).toPixel(startingPoint, radius);
        switch(this.z){
            case TileCornerDirection.North:
                return new Point(hexagonPixel.x, hexagonPixel.y - radius);
            case TileCornerDirection.South:
                return new Point(hexagonPixel.x, hexagonPixel.y + radius);
        }
    }
    touchingFaces() {
        const faces = [];
        switch(this.z){
            case TileCornerDirection.North:
                faces.push(new HexFace(this.x + 1, this.y - 1));
                faces.push(new HexFace(this.x, this.y));
                faces.push(new HexFace(this.x, this.y - 1));
                break;
            case TileCornerDirection.South:
                faces.push(new HexFace(this.x, this.y));
                faces.push(new HexFace(this.x, this.y + 1));
                faces.push(new HexFace(this.x - 1, this.y + 1));
                break;
        }
        return faces;
    }
    touchingEdges() {
        const edges = [];
        switch(this.z){
            case TileCornerDirection.North:
                edges.push(new HexEdge(this.x + 1, this.y - 1, TileEdgeDirection.West));
                edges.push(new HexEdge(this.x + 1, this.y - 1, TileEdgeDirection.SouthWest));
                edges.push(new HexEdge(this.x, this.y, TileEdgeDirection.NorthWest));
                break;
            case TileCornerDirection.South:
                edges.push(new HexEdge(this.x, this.y + 1, TileEdgeDirection.NorthWest));
                edges.push(new HexEdge(this.x, this.y + 1, TileEdgeDirection.West));
                edges.push(new HexEdge(this.x, this.y, TileEdgeDirection.SouthWest));
                break;
        }
        return edges;
    }
    adjacentCorners() {
        const corners = [];
        switch(this.z){
            case TileCornerDirection.North:
                // noinspection TsLint
                corners.push(new HexCorner(this.x + 1, this.y - 2, TileCornerDirection.South));
                corners.push(new HexCorner(this.x + 1, this.y - 1, TileCornerDirection.South));
                corners.push(new HexCorner(this.x, this.y - 1, TileCornerDirection.South));
                break;
            case TileCornerDirection.South:
                corners.push(new HexCorner(this.x, this.y + 1, TileCornerDirection.North));
                // noinspection TsLint
                corners.push(new HexCorner(this.x - 1, this.y + 2, TileCornerDirection.North));
                corners.push(new HexCorner(this.x - 1, this.y + 1, TileCornerDirection.North));
                break;
        }
        return corners;
    }
    sameCorner(corner) {
        if (this.x != corner.x) return false;
        if (this.y != corner.y) return false;
        if (this.z != corner.z) return false // noinspection RedundantIfStatementJS
        ;
        return true;
    }
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
export class HexEdge {
    get id() {
        return `${this.x}-${this.y}-${this.z}`;
    }
    endPoints() {
        const corners = [];
        switch(this.z){
            case TileEdgeDirection.NorthWest:
                corners.push(new HexCorner(this.x, this.y - 1, TileCornerDirection.South));
                corners.push(new HexCorner(this.x, this.y, TileCornerDirection.North));
                break;
            case TileEdgeDirection.West:
                corners.push(new HexCorner(this.x - 1, this.y + 1, TileCornerDirection.North));
                corners.push(new HexCorner(this.x, this.y - 1, TileCornerDirection.South));
                break;
            case TileEdgeDirection.SouthWest:
                corners.push(new HexCorner(this.x, this.y, TileCornerDirection.South));
                corners.push(new HexCorner(this.x - 1, this.y + 1, TileCornerDirection.North));
                break;
        }
        return corners;
    }
    centerPointToPixel(mapCenter, hexagonSide) {
        // Site to visualize hexagones and the name of the parts: https://www.omnicalculator.com/math/hexagon
        const hexagonCenter = new HexFace(this.x, this.y).toPixel(mapCenter, hexagonSide);
        // Uses the inner circle of a hexagon to calculate the x, y point in the center of the edge
        const hexagonApothem = hexagonSide / 2 * Math.sqrt(3);
        const angle = this.getDirectionAngle();
        const xCoordinate = hexagonApothem * Math.cos(Math.PI * 2 * angle / 360);
        const yCoordinate = hexagonApothem * Math.sin(Math.PI * 2 * angle / 360);
        return new Point(hexagonCenter.x + xCoordinate, hexagonCenter.y + yCoordinate);
    }
    getDirectionAngle() {
        switch(this.z){
            case TileEdgeDirection.NorthWest:
                return 240;
            case TileEdgeDirection.West:
                return 180;
            case TileEdgeDirection.SouthWest:
                return 120;
        }
    }
    touchingFaces() {
        const faces = [];
        faces.push(new HexFace(this.x, this.y));
        switch(this.z){
            case TileEdgeDirection.NorthWest:
                faces.push(new HexFace(this.x, this.y - 1));
                break;
            case TileEdgeDirection.West:
                faces.push(new HexFace(this.x - 1, this.y));
                break;
            case TileEdgeDirection.SouthWest:
                faces.push(new HexFace(this.x - 1, this.y + 1));
                break;
        }
        return faces;
    }
    sameEdge(edge) {
        if (this.x != edge.x) return false;
        if (this.y != edge.y) return false;
        if (this.z != edge.z) return false;
        return true;
    }
    constructor(x, y, z){
        this.x = x;
        this.y = y;
        this.z = z;
    }
}
